import { Controller } from "@hotwired/stimulus"

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export default class extends Controller {
  static targets = ["overlay", "dialog"]
  static values = { url: String }

  open(event) {
    event.preventDefault()
    if (!this.overlayTarget.classList.contains("hidden")) return

    this._previouslyFocused = document.activeElement
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    const frame = this.element.querySelector("turbo-frame")
    if (frame && this.urlValue && !frame.src) {
      frame.src = this.urlValue
    }

    if (this._keyHandler) {
      document.removeEventListener("keydown", this._keyHandler)
    }
    this._keyHandler = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._keyHandler)

    requestAnimationFrame(() => {
      if (this.hasDialogTarget) {
        const first = this.dialogTarget.querySelector(FOCUSABLE)
        if (first) first.focus()
        else this.dialogTarget.focus()
      }
    })
  }

  close(event) {
    if (event) event.preventDefault()
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")

    if (this._keyHandler) {
      document.removeEventListener("keydown", this._keyHandler)
      this._keyHandler = null
    }

    if (this._previouslyFocused && this._previouslyFocused.focus) {
      this._previouslyFocused.focus()
      this._previouslyFocused = null
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
      return
    }

    if (event.key === "Tab" && this.hasDialogTarget) {
      const focusable = [...this.dialogTarget.querySelectorAll(FOCUSABLE)]
      if (focusable.length === 0) return

      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault()
          last.focus()
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      }
    }
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    if (this._keyHandler) {
      document.removeEventListener("keydown", this._keyHandler)
    }
  }
}
